import { useTranslation } from 'react-i18next'

export const Colon = () => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  return <span>{currentLanguage === 'fr' ? ' :' : ':'}</span>
}
